<div class="">
  <!------------------------------------------ HEADER IMAGE --------------------------------------->
  <!------------------------------------------TITLE----------------------------------------------->
  <div class="title-box uk-border-rounded p-1  ">
    <div class="head-card p-1 inner-title-box">
      <h1 class="title-text text-center font-weight-bold">Gallery</h1>

    </div>
    <!-- <div class="col-md-2 col-sm-6 col-xs-12">
				<button class="Youtube-btn">
					<a class="a-link" href="https://youtube.com/@thirukkadaiyurtemple?si=05s-iswihf4A8LJn" target="_blank" style="color: whitesmoke;">
						YOUTUBE
					</a>
				</button>
			</div> -->
    <div class="col-md-2 col-sm-6 col-xs-12">
      <button class="Instagram-btn">
        <a class="a-link"
          href="https://www.instagram.com/sriparasakthividyalayacbse?utm_source=qr&igsh=Z2kxNHFucnR6d28y"
          target="_blank" style="color: whitesmoke;">
          INSTAGRAM
        </a>
      </button>
    </div>
    <div class="col-md-2 col-sm-6 col-xs-12">
      <button class="Instagram-btn">
        <a class="a-link"
          href="https://www.youtube.com/@sriparasakthividyalayacbsecour"
          target="_blank" style="color: whitesmoke; display: inline;">
          YOUTUBE
        </a>
      </button>
    </div>
    <!-- <div class="container">
    <div class="box" *ngFor="let link of links">
    <a [href]="link.url" target="_blank">
      <img [src]="link.image" [alt]="link.text">
    </a>
    <a [href]="link.url" class="btn" target="_blank">{{ link.text }}</a>
    </div>
    </div> -->
  </div>
  <!--------------------------------------------------TITLE END-------------------------------------------->
  <!------------------------------------------ END ------------------------------------------------->

  <!------------------------------------------ WEBSITES---------------------------------------------->
  <div class="bg-light">
    <div class="container-fluid">
      <h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">Gallery</h4>
      <div class="gallery-container">
        <div *ngIf="images1.length === 0">No images available.</div>
        <div *ngFor="let image of images1" class="image-item">
          <p class="image-id mb-1">ID: {{ image.id }}</p>
          <div class="image-wrapper text-center">
            <img *ngIf="image.url" [src]="image.url" [alt]="image.name" class="img-thumbnail mt-2" loading="lazy"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<!-- <div class="d-block d-sm-none">

<div class="gallery-container">
  <div *ngIf="images1.length === 0">No images available.</div>
  <div *ngFor="let image of images1" class="image-item">
    <div class="image-wrapper">
      <img
        *ngIf="image.url"
        [src]="image.url"
        [alt]="image.name"
        class="img-thumbnail mt-2"
      />
    </div>
  </div>
</div>
 
</div> -->